/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Track_Intensity_Faint_DescInputs */

const en_ui_track_intensity_faint_desc = /** @type {(inputs: Ui_Track_Intensity_Faint_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single passes stay subtle – your regular routes glow.`)
};

const de_ui_track_intensity_faint_desc = /** @type {(inputs: Ui_Track_Intensity_Faint_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelne Runden bleiben dezent – deine Stammstrecken leuchten.`)
};

/**
* | output |
* | --- |
* | "Single passes stay subtle – your regular routes glow." |
*
* @param {Ui_Track_Intensity_Faint_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_track_intensity_faint_desc = /** @type {((inputs?: Ui_Track_Intensity_Faint_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Track_Intensity_Faint_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_track_intensity_faint_desc(inputs)
	return de_ui_track_intensity_faint_desc(inputs)
});